import "../../utils/tailwind.css";
import { PageProvider, useAddWorkProvider } from "./provider";
import { useState } from "react";
import Label from "../../components/label";
import Section from "../../components/section";
import { FormikInput } from "../../components/input";
import Button from "../../components/Buttons";
import { Formik, Form, ErrorMessage } from "formik";
import ReactQuill from "react-quill";
import Switch from "../../components/switch";
import ImageUploader from "../../components/upload-image";
import slugify from "slugify";
import * as Yup from "yup";
import ScrolltoFormError from "../../components/scroll-to-form-error";

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { initialValues, handleSubmit } = useAddWorkProvider();
  const [isSlugEdited, setIsSlugEdited] = useState(false);
  const validationSchema = Yup.object({
    works: Yup.object({
      title: Yup.string().required("This field is required.").max(100, "Title must be at most 100 characters"),
      description: Yup.string().required("This field is required."),
      banner_img: Yup.string().required("This field is required.")
    }),
  });

  return (
    <Section className="h-[80vh] overflow-y-auto">
      <Label label="Add Blog Details" className="text-[18px] text-black" />
      <Formik initialValues={initialValues} validationSchema={validationSchema} enableReinitialize={true} onSubmit={handleSubmit}>
        {({ values, setFieldValue, errors }) => (
          <Form>
            <ScrolltoFormError>
              <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-3">
                <div className="flex items-center space-x-2">
                  <Label label="Is Published ?" className="text-black mr-4 mt-3 text-[15px]" />
                  <Switch
                    className="pt-1"
                    type="switch"
                    name="is_publish"
                    onChange={(val) => setFieldValue("works.is_publish", val)}
                    checked={values.works.is_publish}
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                <div className="flex flex-col">
                  <Label label="Meta Title" className="mb-2 text-black text-[15px]" />
                  <FormikInput name="works.meta_title" rootClassName="w-full" />
                </div>

                <div className="flex flex-col">
                  <Label label="Meta Keywords" className="mb-2 text-black text-[15px]" />
                  <FormikInput name="works.meta_keywords" rootClassName="w-full" className="h-[26rem]" />
                </div>
                <div className="flex flex-col ">
                  <Label label="Meta Description" className="mb-2 text-black text-[15px]" />
                  <FormikInput name="works.meta_description" rootClassName="w-full" className="h-[26rem]" />
                </div>
              </div>

              <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 mt-2 gap-3">
                <div className="flex flex-col">
                  <Label label="Heading" className="mb-2 text-black text-[15px]" />
                  <FormikInput
                    name="works.title"
                    rootClassName="w-full"
                    value={values.works?.title || ""}
                    onChange={(e) => {
                      const newTitle = e.target.value;
                      setFieldValue("works.title", newTitle);
                      if (!isSlugEdited) {
                        setFieldValue("works.slug_url", slugify(newTitle, { lower: true }));
                      }
                    }}
                  />
                </div>

                <div className="flex flex-col">
                  <Label label="Slug URL" className="mb-2 text-black text-[15px]" />
                  <FormikInput
                    name="works.slug_url"
                    rootClassName="w-full"
                    value={values.works?.slug_url || ""}
                    onChange={(e) => {
                      setIsSlugEdited(true);
                      setFieldValue("works.slug_url", e.target.value);
                    }}
                  />
                </div>

                <div className="flex flex-col">
                  <Label label="Keywords (' , ' seperated)" className="mb-2 text-black text-[15px]" />
                  <FormikInput name="works.keywords" rootClassName="w-full" />
                </div>
              </div>
              <div className="w-full mt-3">
                <div className="flex flex-col">
                  <Label label="Description" className="mb-2 text-black text-[15px]" />
                  <ReactQuill theme="snow" value={values.works.description} onChange={(e) => setFieldValue("works.description", e)} />
                  <ErrorMessage name="works.description">
                    {(msg) => <div className="form-error text-red-500 mt-1 text-xs form-field-error">{msg}</div>}
                  </ErrorMessage>
                </div>
              </div>
              <Label label="Banner Image" className="mt-3 text-black text-[15px]" />
              <div className="w-full  mb-5 ">
                <ImageUploader
                  imageUrl={values.works.banner_img}
                  onChange={(res) => {
                    setFieldValue(`works.banner_img`, res?.data?.file_url);
                  }}
                />
                <ErrorMessage name="works.banner_img">
                  {(msg) => <div className="form-error text-red-500 mt-1 text-xs form-field-error">{msg}</div>}
                </ErrorMessage>
              </div>
              <div className="fixed bottom-0 left-0 w-full bg-white flex justify-end items-center py-3 pr-4 space-x-3 shadow-md">
                <Button type="submit">Save</Button>
              </div>
            </ScrolltoFormError>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
